export const getAnnotationTypes = (state) => {
  return state.annotationTypes;
};
